import Widget from "csi/form/Widget";
import locale from "csi/locale";
import reflection from "csi/reflection";
import reflectionHints from "csi/reflectionHints";
import declare from "dojo/_base/declare";
import util from "csi/util";
import Memory from "dojo/store/Memory";
import csi from "csi/main";
import { ComponentItem } from "designSystem/types/component-item-types";

const SOURCE_FILE = "SourceFile";
export const SUPPORTED_FILE_EXTENSION = ".docx";
const FIELD_PRIMARY_TYPE = "PrimaryType";
const FIELD_PRIMARY_SUBTYPE = "PrimarySubtype";

const DGaaSForm = declare(Widget, {
	/** @property {Store} classesList - Variable to hold all reflection classes */
	classesList: null,

	loadClassList() {
		// fetch the class list
		const ownerList = reflectionHints.getReferenceDocumentOwners();
		this.classesList = ownerList.reduce((memo: ComponentItem[], type: string) => {
			const rc = reflection.getClass(type);
			if (rc && rc.isDocAndCommentOwner && !rc.abstract && !rc.isPrivate() && rc.enabled) {
				memo.push({ id: type, name: `${locale.type(type)} (${type})` });
			}
			return memo;
		}, []);
	},

	/**
	 * @override
	 * Filter files with .docx extension for upload
	 */
	_resolveView: function() {
		this.inherited(arguments);
		var fileField = this.getField(SOURCE_FILE);
		fileField.widgetParams = {
			accept: SUPPORTED_FILE_EXTENSION,
		};
		// disable the PrimarySubtype field initially
		const primarySubtypeField = this.getField(FIELD_PRIMARY_SUBTYPE);
		this.setFieldDisabled(primarySubtypeField, true);
	},

	/**
	 * Activate primarySubtype when primaryType changes
	 */
	_onChangePrimaryType(defView, field, value) {
		const primarySubtypeField = this.getField(FIELD_PRIMARY_SUBTYPE);
		const rc = reflection.getClass(value);
		const enableSubtypeField = rc.isSubtyped || value === "Style" || value === "Material";
		// Disable primarySubtypeField if value is "Factory" or "Supplier"
		const disablePrimarySubtypeField = value === "Factory" || value === "Supplier";
		this.setFieldDisabled(primarySubtypeField, !enableSubtypeField || disablePrimarySubtypeField);
	},

	/**
	 * This method handles the file selection event. It checks if the selected file
	 * is a valid .docx file. If an invalid file is selected, an error message is displayed.
	 * Upon resubmission with a valid .docx file, the error message is removed.
	 */
	_onChangeFileField(defView, field, value) {
		const fileToRead = field.m_control.files[0];
		const ext = util.getFileExtension(fileToRead.name);
		if (!SUPPORTED_FILE_EXTENSION.includes(ext)) {
			field.errorMessage = locale.resource("UnsupportedDGaaSTemplateFile");
		} else {
			field.errorMessage = "";
		}
		this.errorForm(field.errorMessage, "");
	},

	/**
	 * @override
	 */
	getFieldStore(field, value) {
		if (this.classesList === null) {
			this.loadClassList();
		}
		if (field.getControlName() == FIELD_PRIMARY_TYPE) {
			return new Memory({
				data: csi.sort(this.classesList, "name"),
			});
		}
		return this.inherited(arguments);
	},
});
export default DGaaSForm;
